import {
    NinchatActionType,
    NinchatDiscoverJitsiAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatJitsiDiscoveredEvent} from '../types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'
import {jitsiMeetRoomDetails} from 'actions/jitsi'

const actionTypePrefix = 'NINCHAT/action'

export const discoverJitsi = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDiscoverJitsiAction}`,
    async (arg: NinchatActionParams<NinchatDiscoverJitsiAction>, thunkAPI) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDiscoverJitsiAction

        try {
            const event = await ninchatClient.send(params) as NinchatJitsiDiscoveredEvent

            thunkAPI.dispatch(jitsiMeetRoomDetails({
                jitsi_room: event.jitsi_room,
                jitsi_token: event.jitsi_token,
            }))

            return event
        } catch (err) {
            return thunkAPI.rejectWithValue(err)
        }
    },
)
